// @flow

const userDidItDataActionTypes: Object = {
  USER_DID_IT_DATA_CREATE: 'USER_DID_IT_DATA_CREATE',
  USER_DID_IT_DATA_DELETE: 'USER_DID_IT_DATA_DELETE',
  USER_DID_IT_DATA_UPDATE: 'USER_DID_IT_DATA_UPDATE',
  USER_DID_IT_DATA_UPDATE_COMMENT_COUNT: 'USER_DID_IT_DATA_UPDATE_COMMENT_COUNT',
  USER_DID_IT_DATA_FETCH: 'USER_DID_IT_DATA_FETCH',
};

export default userDidItDataActionTypes;
